module.exports = __webpack_public_path__ + "static/media/Logo211UW.6067b6b1.png";